export interface IProps { }

export interface IAccountDeletionState {
  phoneNumber: string;
  otp: string;
  isOtpSent: boolean;
  isLoading: boolean;
  error: string | null;
  success: boolean;
}

export const AccountDeletionSteps = {
  PHONE_INPUT: 'PHONE_INPUT',
  OTP_VERIFICATION: 'OTP_VERIFICATION',
  SUCCESS: 'SUCCESS'
} as const;

export type AccountDeletionStep = typeof AccountDeletionSteps[keyof typeof AccountDeletionSteps];